// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rY9zL","disabled":"styles_disabled__3WgGb"};